import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const STAFF_ROLES = new Set(["super_admin", "admin", "team_manager", "content_writer", "sales"]);

export default function NotFound() {
  const { user } = useApp();
  const isStaff = user && STAFF_ROLES.has(user.role);

  return (
    <>
      <Header />
      <main
        className="min-h-[70vh] flex items-center justify-center px-6 py-24"
        data-testid="not-found-page"
      >
        <div className="max-w-xl text-center">
          <div
            className="text-[11px] tracking-[0.28em] uppercase text-[#C85A32] font-bold mb-6"
            data-testid="not-found-eyebrow"
          >
            404 — page not found
          </div>
          <h1
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#1B1B1B] mb-6"
            data-testid="not-found-title"
          >
            This blueprint isn&apos;t on file.
          </h1>
          <p className="text-[#555] text-base sm:text-lg leading-relaxed mb-10">
            The page you were looking for has been moved, renamed, or never existed.
            Let&apos;s get you back to something more useful.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="inline-flex items-center justify-center px-6 py-3 bg-[#2C4C3B] text-white text-sm font-medium rounded-none hover:bg-[#1e3628] transition-colors"
            >
              Return to homepage
            </Link>
            <Link
              to="/plans"
              data-testid="not-found-browse-btn"
              className="inline-flex items-center justify-center px-6 py-3 border border-[#2C4C3B] text-[#2C4C3B] text-sm font-medium rounded-none hover:bg-[#2C4C3B]/5 transition-colors"
            >
              Browse house plans
            </Link>
            {isStaff && (
              <Link
                to="/admin"
                data-testid="not-found-admin-btn"
                className="inline-flex items-center justify-center px-6 py-3 border border-[#C85A32] text-[#C85A32] text-sm font-medium rounded-none hover:bg-[#C85A32]/5 transition-colors"
              >
                Go to admin dashboard
              </Link>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
